import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll(example, pageable) {
    let params = utils.merge(example, pageable);
    return httpService.get("tkTaskDocRelation", {params: params});
  },

  delete(id) {
    return httpService.delete("tkTaskDocRelation/" + id);
  },

  addTkTaskDocRelations(form) {
    return httpService.post("tkTaskDocRelation/addTkTaskDocRelations", form);
  }
}



// WEBPACK FOOTER //
// ./src/services/tkTaskDocRelationService.js